import type { WorkbookDerivation } from '@mathflat/domain/Derivation'

import { DTO } from '../DTO'

// 교재로 n차 학습지를 만들기 위해 옵션을 보내면 리턴받는 값

export class WorkbookDerivationResponse
  extends DTO
  implements Omit<WorkbookDerivation, 'problemIdList'>
{
  problemList: WorkbookDerivation['problemList']
  baseProblemCount: WorkbookDerivation['baseProblemCount']
  conceptIdList: WorkbookDerivation['conceptIdList']
  conceptSize: WorkbookDerivation['conceptSize']
  problemSize: WorkbookDerivation['problemSize']
  worksheetLayout: WorkbookDerivation['worksheetLayout']

  constructor(data: WorkbookDerivation) {
    super()

    this.problemList = data.problemList
    this.baseProblemCount = data.baseProblemCount
    this.conceptIdList = data.conceptIdList
    this.conceptSize = data.conceptSize
    this.problemSize = data.problemSize
    this.worksheetLayout = data.worksheetLayout
  }
}
